import React from 'react';
import { DatePicker } from '@material-ui/pickers';
import moment from 'moment';
import { FormHelperText, Icon, InputAdornment } from '@material-ui/core';

export interface IDateInputProps {
    label : string;
    onDateChange : (date : moment.Moment | null) => void;
    onBlur ?: () => void;
    className ?: string;
    disabled ?: boolean;
    error ?: string;
    value : moment.Moment | null;
    format ?: string;
}

const DateInput = (props : IDateInputProps) : React.ReactElement => {
    const {
        label,
        className,
        disabled,
        error,
        value,
        format = 'YYYY-MM-DD',
    } = props;

    const onChange = (date : moment.Moment | null) : void => {
        if (date != null) {
            props.onDateChange(date);
            if (props.onBlur) {
                props.onBlur();
            }
        }
    };

    return (
        <div className={`fdc ais jcfs ${className || ''}`}>
            <DatePicker
                disabled={disabled}
                value={value}
                onChange={onChange}
                format={format}
                label={label}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position='end'>
                            <Icon>date_range</Icon>
                        </InputAdornment>
                    ),
                }}
            />
            <FormHelperText error>{error || ''}</FormHelperText>
        </div>
    );
};

export default DateInput;
